import Icon from '@ant-design/icons'

const SettingSVG = () => (
    <svg
        t='1707016320852'
        // className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='4596'
        width='200'
        height='200'
    >
        <path
            d='M279.142 542.18c0 59.298-47.994 107.36-107.194 107.36-59.178 0-107.172-48.062-107.172-107.36 0-59.29 47.994-107.35 107.172-107.35 59.2 0 107.194 48.06 107.194 107.35zM626.881 534.606c0 59.298-47.992 107.36-107.192 107.36-59.18 0-107.173-48.062-107.173-107.36 0-59.3 47.993-107.35 107.173-107.35 59.2 0 107.192 48.05 107.192 107.35zM959.518 534.606c0 59.298-47.993 107.36-107.194 107.36-59.18 0-107.172-48.062-107.172-107.36 0-59.3 47.993-107.35 107.172-107.35 59.2 0 107.194 48.05 107.194 107.35z'
            fill='currentColor'
            p-id='4597'
        ></path>
    </svg>
)

export const SettingIcon = props => <Icon component={SettingSVG} {...props} />
